// import React from "react";
import { Route, Routes } from "react-router-dom";
import "../happyerpCss/HappyerpIndex.scss";
import "../happyerpCss/HappyerpIndex.css";

// import pages
// import BusinessOneHeader from "../businessOneComponents/BusinessOneHeader";
import HappyerpHome from "../happyerpPages/happyerpStaticPages/happyerpHome/HappyerpHome";
import GlobalRoute from "../../../global route/GlobalRoute";
import Navbar from "../../../default-components/Navbar";
import ColorsComponent from "../../../default-components/ColorsComponent";
import HappyerpDashboard from "../happyerpPages/happyerpDynamicPages/happyerpAdmin/HappyerpDashBoard";
import HappyerpAboutUs from "../happyerpPages/happyerpStaticPages/aboutus/HappyerpAboutUs";
import HappyerpSales from "../happyerpPages/happyerpDynamicPages/happyerpSales/HappyerpSales";
import HappyerpOrderReport from "../happyerpPages/happyerpDynamicPages/happyerpOrderReport/HappyerpOrderReport";
import HappyerpOrderDetail from "../happyerpComponents/cardDetail/HappyerpOrderDetail";
import HappyerpNewSalesOrder from "../happyerpPages/happyerpDynamicPages/happyerpSales/HappyerpNewSalesOrder";

const happyerpRoute = () => {
  return (
    <div className="happyerp">
      {/* <BusinessOneHeader /> */}
      <Navbar />
      <Routes>
        <Route path="/" element={<HappyerpHome />}></Route>
        <Route path="/dashboard" element={<HappyerpDashboard />}></Route>
        <Route path="/aboutus" element={<HappyerpAboutUs />} />
        <Route path="/sales" element={<HappyerpSales />} />
        <Route path="/order-report" element={<HappyerpOrderReport />} />
        <Route
          path="/order-detail/:orderId"
          element={<HappyerpOrderDetail />}
        />
        <Route path="/new-order" element={<HappyerpNewSalesOrder />} />
      </Routes>
      <GlobalRoute />
      <ColorsComponent />
      {/* <Footer /> */}
    </div>
  );
};

export default happyerpRoute;
